import { useEffect, useState } from 'react';
import { usePostMessage, useReceiveMessage } from '../../context/messageContext';

const useNextStimulusCountdown = () => {
  const [countdownRunning, setCountdownRunning] = useState(false);
  const [countdownTime, setCountdownTime] = useState(5000);
  const [readyForNextStimulus, setReadyForNextStimulus] = useState(true);
  const [showStimulus, setShowStimulus] = useState(false);
  const messageFromOptician = useReceiveMessage();
  const postMessage = usePostMessage();

  // useEffect(() => {
  //   if (!countdownRunning) return;
  //   const countdownInterval = setInterval(() => {
  //     setCountdownTime((currentTime) => {
  //       return currentTime - 1000;
  //     });
  //   }, 1000);

  //   return () => clearInterval(countdownInterval);
  // }, [countdownRunning]);

  // const startCountdown = useCallback(() => {
  //   setCountdownTime(5000);
  //   setCountdownRunning(true);
  //   setShowStimulus(true);
  //   setReadyForNextStimulus(true);
  // }, []);

  useEffect(() => {
    // if (messageFromOptician.type === 'pauseTest') {
    //   setCountdownRunning(false);
    // }

    if (messageFromOptician.type === 'clearStimulus') {
      setReadyForNextStimulus(false);
      setShowStimulus(false);
      // setCountdownRunning(false);
    }
    if (messageFromOptician.type === 'nextStimulus') {
      setShowStimulus(true);
      setReadyForNextStimulus(true);
    }

    if (messageFromOptician.type === 'stopTest' || messageFromOptician.type === 'resetTest') {
      // setCountdownRunning(false);
      setShowStimulus(false);
      setReadyForNextStimulus(true);
    }
  }, [messageFromOptician]);

  // useEffect(() => {
  //   if (countdownTime === 0) {
  //     postMessage({ type: 'destroyStimulus' });
  //   }
  // }, [countdownTime, postMessage]);

  // useEffect(() => {
  //   if (countdownTime === 0) {
  //     setShowStimulus(false);
  //     setCountdownRunning(false);
  //     // const delayBeforeNextStimulus = setTimeout(() => {
  //     //   return setReadyForNextStimulus(true);
  //     // }, 4000);
  //     // return () => clearTimeout(delayBeforeNextStimulus);
  //   }
  // }, [countdownTime]);

  return { showStimulus, readyForNextStimulus };
};

export default useNextStimulusCountdown;
